<template>
  <svg :width="widthValue" :height="heightValue" viewBox="0 0 16 14" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M7.99982 0C8.44357 0 8.85295 0.234375 9.07795 0.61875L15.8279 12.1187C16.0561 12.5062 16.0561 12.9844 15.8342 13.3719C15.6123 13.7594 15.1967 14 14.7498 14H1.24982C0.802948 14 0.387323 13.7594 0.165448 13.3719C-0.0564269 12.9844 -0.0533019 12.5031 0.171698 12.1187L6.9217 0.61875C7.1467 0.234375 7.55607 0 7.99982 0ZM7.99982 4C7.5842 4 7.24982 4.33437 7.24982 4.75V8.25C7.24982 8.66562 7.5842 9 7.99982 9C8.41545 9 8.74982 8.66562 8.74982 8.25V4.75C8.74982 4.33437 8.41545 4 7.99982 4ZM8.99982 11C8.99982 10.7348 8.89447 10.4804 8.70693 10.2929C8.51939 10.1054 8.26504 10 7.99982 10C7.73461 10 7.48025 10.1054 7.29272 10.2929C7.10518 10.4804 6.99982 10.7348 6.99982 11C6.99982 11.2652 7.10518 11.5196 7.29272 11.7071C7.48025 11.8946 7.73461 12 7.99982 12C8.26504 12 8.51939 11.8946 8.70693 11.7071C8.89447 11.5196 8.99982 11.2652 8.99982 11Z" fill="#E1241B"/>
  </svg>
</template>

<script>
export default {
  name: 'AllertCart',

  props: {
    heightValue: Number,
    widthValue: Number
  }
}

</script>
<style lang='scss'>
</style>
